import { Outlet } from "react-router-dom";

export default function MainHeader() {
    return (<>
           <Outlet/>
        </>)
}